$ = jQuery;
export const scroll = {
  init: function () {
    $(window).scroll(this.scrolling);
    $(".anchor-nav").on("click", function (e) {
      e.preventDefault();
      const target = $(this).attr("href");
      gsap.to(window, {
        scrollTo: {
          y: "#" + target,
          offsetY: 150,
        },
        duration: 1.5,
        ease: "power3.inOut",
      });
    });
  },
  scrolling: () => {
    const w = $(window).outerWidth();
    const scrollTop = $(window).scrollTop();
    let delta = w <= 768 ? 96 : 48;
    if($('.site-content').hasClass('no-toolbar')) {
      delta = 0;
    }

    if (scrollTop > delta && !$("body").hasClass("menu-fixed")) {
      $("body").addClass("menu-fixed");
    } else if (scrollTop < delta) {
      $("body").removeClass("menu-fixed");
    }
  }
};
